import {get} from '@/lib/request'

function affiliationIndexPath() {
  return `/wp/v2/affiliations?_embed`
}

export function listAffiliations(params = {}) {
  return get(affiliationIndexPath(), params)
}
